<template>
  <div class="map-pointMonitor">
    <div id="my-map"></div>
  </div>
</template>

<script>
let map = null;
const pointList = [
  {
    name: "仁和水厂",
    coordinates: [120.06669403, 30.48615329],
  },
  {
    name: "奉口",
    coordinates: [120.06872177, 30.44549192],
  },
  {
    name: "武林头",
    coordinates: [120.14847056, 30.46968895],
  },
  {
    name: "五福桥",
    coordinates: [120.14348164, 30.46692286],
  },
  {
    name: "塘栖大桥",
    coordinates: [120.15010536, 30.46298107],
  },
  {
    name: "馒头山水库",
    coordinates: [119.70949888, 30.43262508],
  },
  {
    name: "木鱼岭",
    coordinates: [119.82191563, 30.43411905],
  },
  {
    name: "四岭水库",
    coordinates: [119.78800178, 30.41792465],
  },
  {
    name: "瓶窑大桥",
    coordinates: [119.97066021, 30.3956223],
  },
  {
    name: "瓶窑水厂",
    coordinates: [119.96793509, 30.37880832],
  },
  {
    name: "张堰大桥",
    coordinates: [119.9411881, 30.37088159],
  },
  {
    name: "落塘埠",
    coordinates: [119.94472727, 30.34653621],
  },
  {
    name: "义桥",
    coordinates: [120.12803077, 30.37828074],
  },
  {
    name: "石祥路运河桥",
    coordinates: [120.13747752, 30.33433115],
  },
  {
    name: "径山",
    coordinates: [119.81146574, 30.32641586],
  },
  {
    name: "汪家埠",
    coordinates: [119.8720622, 30.25500813],
  },
  {
    name: "仓前桥",
    coordinates: [119.96179417, 30.27523926],
  },
  {
    name: "长桥",
    coordinates: [120.0367713, 30.30263141],
  },
  {
    name: "师母桥泵站",
    coordinates: [120.0501354, 30.27702867],
  },
];
import AMap from "AMap";
export default {
  name: "PointMonitor",
  data() {
    return {};
  },
  mounted() {
    this.initMap();
    this.addPoints();
  },
  methods: {
    addPoints() {
      let marker = null;
      let markerList = [];
      pointList.forEach((item) => {
        marker = new AMap.Marker({
          position: item.coordinates,
          title: item.name,
        });
        marker.setLabel({
            direction: "center",
            offset: new AMap.Pixel(0, -28), //设置文本标注偏移量
            content: item.name ? "<span class='marker-label'>" + item.name + "</span>" : "", //设置文本标注内容
          });
        markerList.push(marker);
      });

      map.add(markerList);
      this.$nextTick(() => {
        map.setFitView();
      });
    },
    initMap() {
      map = new AMap.Map("my-map", {
        resizeEnable: true,
        zoom: 12,
        zooms: [3, 20],
        expandZoomRange: true,
        layers: [
          new AMap.TileLayer.Satellite(),
          // 路网
          //   new AMap.TileLayer.RoadNet(),
        ],
      });
      // scale 比例尺
      AMap.plugin(["AMap.Scale"], () => {
        let scale = new AMap.Scale({
          visible: true,
        });
        map.addControl(scale);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.map-pointMonitor {
  width: 100%;
  height: 100%;
  #my-map {
    width: 100%;
    height: 100%;
    min-height: 720px;
  }
  /deep/ .amap-marker-label{
    border: none;
    padding: 2px;
    color: #fff;
    background-color: rgba(0,0,0,0.3);
  }
  /deep/ .amap-scalecontrol {
    margin-left: 10px;
    .amap-scale-text {
      color: #fff !important;
    }
  }
}
</style>
